import { FormattedMessage, useIntl } from 'react-intl'
import { useState } from 'react'

import { useAppSelector } from 'app/hooks'
import {
  currentRootDomainIdSelector,
  rootDomainByIdSelector,
} from 'features/rootDomains/selectors'
import { AboutMessages } from './messages'
import {
  AboutCompanyWrapper,
  AboutCompanyPanel,
  AboutCompanyInfo,
  AboutCompanyPageHeader,
  AboutCompanyNameHeader,
  AboutCompanyDisclaimer,
  CompanyDetail,
  CompanyImageWrapper,
} from './styles'
import { CompanyImageUploader } from './CompanyImageUploader'
import CompanyImage from 'components/Image/CompanyImage'
import usePermissions from 'features/auth/permissions/usePermissions'
import { ROOT_ADMIN } from 'features/auth/permissions/consts'

function About() {
  const { formatMessage } = useIntl()
  const [uploadingPropgress, setUploadingProgress] = useState<number>()

  const currentRootDomainId = useAppSelector(currentRootDomainIdSelector)
  const rootDomain = useAppSelector(rootDomainByIdSelector(currentRootDomainId))
  const [hasRootAdminPermission] = usePermissions({ allow: [ROOT_ADMIN] })

  if (!rootDomain) {
    return null
  }

  return (
    <AboutCompanyWrapper>
      <AboutCompanyPageHeader>
        {formatMessage(AboutMessages.aboutHeader)}
      </AboutCompanyPageHeader>

      <AboutCompanyPanel>
        <AboutCompanyInfo>
          <CompanyImageWrapper>
            {rootDomain.imageUrl ? (
              <CompanyImage
                src={rootDomain?.imageUrl}
                alt=" "
                large
                uploadingProgress={uploadingPropgress}
              />
            ) : (
              <div>
                <FormattedMessage {...AboutMessages.noImage} />
              </div>
            )}
            {hasRootAdminPermission && (
              <CompanyImageUploader onProgress={setUploadingProgress} />
            )}
          </CompanyImageWrapper>

          <div>
            <AboutCompanyNameHeader>{rootDomain.name}</AboutCompanyNameHeader>
            <p>
              {formatMessage(AboutMessages.contactEmail, {
                email: <CompanyDetail>{rootDomain.email}</CompanyDetail>,
              })}
            </p>
            <p>
              {formatMessage(AboutMessages.contactPhone, {
                phone: <CompanyDetail>{rootDomain.phone}</CompanyDetail>,
              })}
            </p>
          </div>
        </AboutCompanyInfo>

        <AboutCompanyDisclaimer>
          {formatMessage(AboutMessages.companyDisclaimer)}
        </AboutCompanyDisclaimer>
      </AboutCompanyPanel>
    </AboutCompanyWrapper>
  )
}

export default About
